import styled from 'styled-components';
import { flexBetween, flexCenter, flexColumn, flexRow, media } from '../../styles/helpers';

export const Email = styled.a`
  color: var(--color-ink);
  font-size: 20px;
  text-decoration: none;
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background: #d4dccf;
`;

export const Logo = styled.img`
  height: 80px;
  aspect-ratio: 5/4;
`;

export const BottomLine = styled.div`
  gap: 20px;
  display: flex;
  flex-direction: column-reverse;
  width: 100%;
  max-width: var(--max-content-width);
  padding: 0 20px;
  font-size: 16px;
  margin-top: 30px;
  align-items: center;
  justify-content: space-between;

  a:hover {
    text-decoration: underline;
  }
`;

export const Phone = styled.a`
  display: none;
  font-size: 40px;
  font-weight: 500;
`;

export const Box = styled.div`
  ${flexColumn};
  gap: 20px;
  padding: 0 20px;
  margin: 0 auto;
  max-width: var(--max-content-width);
`;

const laptopStyles = media.laptop`
  ${Phone} {
    display: block;
  }
	${Logo} {
		height: 85px;
	}
  ${Box} {
    width: 100%;
    ${flexRow};
    ${flexBetween};
    align-items: center;
  }
  ${BottomLine} {
    flex-direction: row;
      p {
        display: flex;
        gap: 10px;
      }
  }
`;

export const Wrapper = styled.footer`
  ${flexColumn};
  ${flexCenter};
  gap: 20px;
  padding: 48px 0 28px;
  margin-top: 72px;
  border-top: 1px solid #d4dccf;
  border-radius: 28px 28px 0 0;
  background: #e9eee3;

  a {
    display: flex;
    justify-content: center;
  }

  ${laptopStyles};
`;
